import router from '@/router';


const checkToken = () => {
    
    const token = localStorage.getItem('token');
    if (!token) {
        router.push('/login');
    }

}

export { checkToken };